import { TitlePlaceholderLoader, ListItemPlaceholderLoader } from "@similarweb/ui-components";
import styled from "styled-components";
import { Box } from "@similarweb/ui-components";

const BoxContainer = styled(Box)`
    margin: 0 20px 24px 0;
    height: 154px;
    flex: 1 0 350px;
    max-width: 42%;
    padding: 24px 25px 25px;
    display: flex;
    flex-direction: column;
`;
const StyledListItemPlaceholderLoader = styled(ListItemPlaceholderLoader)<{ marginTop?: string }>`
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : "0px")};
`;
export const WidgetLoader = () => {
    return (
        <BoxContainer>
            <TitlePlaceholderLoader />
            <StyledListItemPlaceholderLoader marginTop={"25px"} />
            <StyledListItemPlaceholderLoader />
        </BoxContainer>
    );
};
